
import {computed, ref} from 'vue'
import {useToast} from "primevue/usetoast";
import AuthRepository from "@/services/AuthRepository";
import {useStore} from "vuex";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
import {UserDetail} from "@/models/userDetail";
import {KhoaPhong} from "@/models/khoaPhong";
import moment from "moment";
import {forEach} from "lodash";
import {UserUpdate} from "@/models/userUpdate";

export default {
  setup() {
    const toast = useToast();
    const list = ref([] as UserDetail[]);
    const store = useStore();
    const update = ref(false);
    const userUpdate = ref({} as UserUpdate);
    const userReport = ref([] as string[]);

    const reportList = ref([
      {label: "BC Cơ sở lao động", key: "bc1"},
      {label: "BC YTLĐ tuyến huyện", key: "bc2"},
      {label: "BC Kiểm dịch y tế", key: "bc3"},
      {label: "BC công tác y tế trường học", key: "bc4"},
      {label: "BC vệ sinh nước sạch", key: "bc5"},
      {label: "BC tiêm vắc xin", key: "bc6"},
      {label: "BC tình hình sử dụng vắcxin", key: "bc7"},
      {label: "BC sàng lọc bệnh KLN và KSKDK", key: "bc8"},
    ]);

    const getInfoUser = (id) => {
      update.value = true;
      AuthRepository.getById(id)
          .then((response) => {
            userUpdate.value = response.data;

            if(userUpdate.value.report != null) {
              userReport.value = userUpdate.value.report.split(",");
            }
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    const doUpdate = () => {
      console.log("#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% doUpdate222222 userUpdate.value.password.length: " + JSON.stringify(userUpdate.value.password));
      console.log("#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% doUpdate222222 userUpdate.value.password. check value: " + (userUpdate.value.password == null));

      const checkValue = ref(false);
      if(userUpdate.value.password == null){
        checkValue.value = true;
      }
      else{
        if(userUpdate.value.password.length < 6 && userUpdate.value.password.length > 0)
        {
          checkValue.value = false;
          toast.add({
            severity: 'error',
            summary: 'Thất bại',
            detail: 'Mật khẩu không hợp lệ, vui lòng nhập lại mật khẩu',
            life: 2000
          });
        }
        else{
          checkValue.value = true;
        }
      }

      if(checkValue.value) {
        userUpdate.value.report = userReport.value.toString();
        AuthRepository.updateUser(userUpdate.value)
            .then((response) => {
              console.log("#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% doUpdate222222: " + JSON.stringify(userUpdate.value));
              toast.add({
                severity: 'success',
                summary: 'Cập nhật',
                detail: 'Cập nhật thông tin tài khoản thành công',
                life: 2000
              });
              loadList();
              update.value = false;
              // router.push({
              //   name: 'home'
              // });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2000
              });
            });
      };
    };


    if(!(store.state.permission == 'admin')){
      router.push({
        name: 'home'
      });
    }

    const userPermission = ref([
      {label: "Quản lý", value: "admin", param: 1},
      {label: "Nhân viên", value: "user", param: 2},
    ]);

    const loadInfo = (str: string) =>{
      if(str != null) {
        const arr = str.split(",");
        const temp = ref("");
        arr.forEach(x => {
          reportList.value.forEach(y => {
            if (y.key == x) {
              temp.value = temp.value + y.label + ", ";
            }
          })
        })
        console.log("@@@@@@@################# loadInfo temp: " + JSON.stringify(temp.value));
        return temp.value;
      }
      else{
        return "";
      }
    }

    const loadList = () => {
      console.log("#######$$$$$$$$$$$%%%%%%%%%%%%%%%%% loadList: ");
      AuthRepository.getListUser()
          .then((response) => {
            list.value = response.data;
            console.log("@@@@@@@################# list.value: " + JSON.stringify(list.value));
            list.value.forEach(x => {
              userPermission.value.forEach(y => {
                if(x.permission == y.value){
                  x.permission = y.label;
                }
              })
            });

            list.value.forEach(x => {
              x.listReport = loadInfo(x.report);
              x.status = activeStatus(x.active);
            })
          })
          .catch();
    }


    loadList();

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const activeStatus = (i) => {
      if(i)
      {
        return "Đang hoạt động";
      }
      else
        return "Đang tạm ngưng"
    };


    return {
      list,
      filters,
      clearFilter,
      initFilters,
      activeStatus,
      loadInfo,
      update,
      doUpdate,
      userUpdate,
      reportList,
      getInfoUser,
      userReport
    }
  }
}
